import _ from 'lodash';
import React, { forwardRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import ErrorMessage from 'shared/components/ErrorMessage';
import styles from './File.module.scss';

const File = forwardRef(({
  title,
  onSelect,
  iconClassName,
  loading,
  error,
  disabled,
  children,
  className,
  ...rest
}, ref) => (
  <span className={cn(styles.wrapper, className)}>
    <label
      className={cn(
        styles.file,
        {
          [styles.error]: !!error,
          [styles.loading]: loading,
          [styles.disabled]: disabled,
        }
      )}
      onClick={
        disabled
          ? (event) => {
            event.preventDefault();
            event.stopPropagation();
          }
          : undefined
      }
    >
      {loading && (<div className={cn('spinner-border', styles.spinner)} />)}
      <i className={iconClassName} />
      <span>{title}</span>
      <input ref={ref} type="file" onChange={onSelect} disabled={loading} {...rest} />
    </label>
    {children}
    {_.isString(error) && <ErrorMessage>{error}</ErrorMessage>}
  </span>
));

File.displayName = 'forwardRef(File)';

File.propTypes = {
  title: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  iconClassName: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

File.defaultProps = {
  onSelect() {},
  iconClassName: '',
  loading: false,
  error: null,
  disabled: false,
  className: null,
};

export default File;
